<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <v-label><b>{{ label }}</b></v-label>
    <section style="display: flex; align-center: center;">
      <v-file-input
        @click:clear="clear()"
        :multiple="multiple"
        small-chips
        :value="value"
        @input="input($event)"
        prepend-icon
        @change="change($event)"
        show-size
        color="primary"
        prepend-inner-icon="mdi-paperclip"
        dense
        hide-details
        outlined
        :accept="fileAccept"
      ></v-file-input>
      <!-- Botón de cámara solo cuando img es true -->
      <v-btn 
        v-if="camera"
        small 
        text
        @click="openCamera"
      >
        <v-icon>mdi-camera</v-icon>
      </v-btn>
    </section>
    
    <!-- Diálogo para capturar foto -->
    <v-dialog v-model="cameraDialog" max-width="500px">
      <v-card>
        <v-card-title>Tomar foto</v-card-title>
        <v-card-text>
          <video 
            v-show="!photoTaken"
            ref="video"
            width="100%"
            autoplay
            playsinline
          ></video>
          <div v-show="photoTaken" style="height: 300px; display: flex; justify-content: center;">
            <canvas 
              style="object-fit: contain;"
              v-show="photoTaken"
              ref="canvas"
              width="400"
              height="300px"
            ></canvas>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="capturePhoto" v-if="!photoTaken">
            Capturar
          </v-btn>
          <v-btn color="success" @click="savePhoto" v-if="photoTaken">
            Guardar
          </v-btn>
          <v-btn color="error" @click="retakePhoto" v-if="photoTaken">
            Volver a tomar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cameraDialog = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Array, File],
      default: () => [],
    },
    config: {
      type: Object,
      default: null,
    },
    label: { type: String, default: "" },
    multiple: {
      type: Boolean,
      default: false,
    },
    camera: { type: Boolean, default: false },
    img: { type: Boolean, default: false },
    pdf: { type: Boolean, default: false },
    excel: { type: Boolean, default: false },
    word: { type: Boolean, default: false },
    ppt: { type: Boolean, default: false },
    video: { type: Boolean, default: false },
  },
  data() {
    return {
      file: null,
      files: null,
      cameraDialog: false,
      photoTaken: false,
      stream: null
    };
  },
  computed: {
    fileAccept() {
      const acceptList = [];

      if (this.img) {
        acceptList.push('image/*');
      }

      if (this.pdf) {
        acceptList.push('application/pdf');
      }

      if (this.excel) {
        acceptList.push('.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      }

      if (this.word) {
        acceptList.push('.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document');
      }

      if (this.ppt) {
        acceptList.push('.ppt,.pptx,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation');
      }

      if (this.video) {
        acceptList.push('video/*');
      }

      return acceptList.join(',');
    }
  },
  watch: {
    files() {
      this.$emit("changeData", this.files);
      console.log(this.files);
    },
  },
  methods: {
    change(files) {
      this.$emit("input", files);
      console.log("regis");
    },
    input(files) {
      this.$emit("input", files);
    },
    send() {
      this.$fun.alert("Seguro de subir Archivo", "question").then((val) => {
        if (val.value) {
          if (this.config != null)
            if (this.value.length > 0) {
              const formData = new FormData();
              formData.append("file", this.files);
              this.$http
                .post(
                  this.config.url,
                  formData
                  // ,  { headers: {'Content-Type': 'multipart/form-data' } }
                )
                .then(() => {
                  this.$fun.alert("Archivo cargado correctamente", "success");
                });
            } else this.$fun.alert("Seleccione Archivo a Cargar", "info");
        }
      });
    },
    clear(item) {
      this.$emit("clear", this.value);
    },
    
    openCamera() {
      this.cameraDialog = true;
      this.photoTaken = false;
      this.$nextTick(() => {
        this.startCamera();
      });
    },
    
    async startCamera() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: 'environment' },
          audio: false
        });
        this.$refs.video.srcObject = this.stream;
      } catch (err) {
        console.error("Error al acceder a la cámara:", err);
        this.$fun.alert("No se pudo acceder a la cámara", "error");
      }
    },
    
    capturePhoto() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const context = canvas.getContext('2d');
      
      // Ajustar el canvas al tamaño del video
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.photoTaken = true;
      
      // Detener el stream de video
      this.stream.getTracks().forEach(track => track.stop());
    },
    
    retakePhoto() {
      this.photoTaken = false;
      this.startCamera();
    },
    
    savePhoto() {
      const canvas = this.$refs.canvas;
      
      // Convertir canvas a Blob
      canvas.toBlob((blob) => {
        // Crear un File desde el Blob
        const file = new File([blob], `foto-${new Date().getTime()}.jpg`, {
          type: 'image/jpeg',
          lastModified: Date.now()
        });
        
        // Emitir el archivo
        this.$emit('input', file);
        this.$emit('change', file);
        
        this.cameraDialog = false;
      }, 'image/jpeg', 0.9);
    },
    
    // Limpiar cuando se cierre el diálogo
    closeCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop());
      }
      this.cameraDialog = false;
    }
  },
  beforeDestroy() {
    // Limpiar el stream al destruir el componente
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }
  }
};
</script>